import { DropdownOption } from '../fb/models/dropdownOption';
import { BuilderField } from '../fb/models/builder.model';
import { BuilderHelper } from './BuilderHelper';

export class BuilderFields {
  /**
   * Returns controls to be rendered in 'basic' tab
   * Order doesnt really matter.
   * @returns Control[]
   */
  get BasicFields(): BuilderField[] {
    return [
      this.TextField,
      this.TextArea,
      this.CheckBox,
      this.ListField,
      this.DateTimeField,
      this.HtmlContent,
      this.SectionLayout,
      this.TableLayout,
      this.EditableGrid,
      // this.FileUpload,
      // this.HiddenField,
      // this.CustomControl,
      // this.BootstrapRow,
      // this.Button,
      // this.RadioButtonList,
      // this.Map,
      // this.NumberRange,
      this.DropDownList,
      this.Email,
      this.Currency,
      this.PhoneNumber,
      this.Number,
      this.DateField,
      this.DateRangeField,
      this.CheckList,
      /// worth of adding?! can be added using customhtml
      // this.Image,
      // this.Label,
      // this.Url,
    ];
  }

  get EditableGrid() {
    const editableGrid = new BuilderField('Editable Grid', 'EditableGrid', BuilderHelper.EFormElement.EditableGrid, 'Grid', 'fa fa-table');
    // editableGrid.editableGrid = {
    //   'columns': [{
    //     'type': 'gridcolumn',
    //     'text': 'default column',
    //     'dataIndex': 'default',
    //   }],
    //   'title': 'Table',
    //   'store': {
    //     'proxy': {
    //       'url': '',
    //       'multilang': true,
    //     },
    //   },
    //   'editHandlers': {
    //     'allowInlineEdit': true,
    //     'addAction': {
    //       'text': 'Add address',
    //       'selectionEnable': true,
    //       'isDblClick': true,
    //       'listeners': [{ 'click': 'Add' }],
    //       'dialogData': new Task(),
    //     },
    //     'editAction': {
    //       'selectionEnable': true,
    //       'isDblClick': true,
    //       'listeners': [{ 'click': 'Edit' }],
    //       'dialogData': new Task(),
    //     },
    //   },
    // };
    return editableGrid;
  }

  get Url() {
    return new BuilderField('URL', 'URL', BuilderHelper.EFormElement.Html, 'URL', 'fa fa-font');
  }

  get Email() {
    return new BuilderField('Email', 'Email', BuilderHelper.EFormElement.Text, 'TextField', 'fa fa-font');
  }

  get Number() {
    return new BuilderField('Number', 'Number', BuilderHelper.EFormElement.Float, 'TextField', 'fa fa-font');
  }

  // get NumberRange() {
  //   // @todo: Implement NumberRange.
  //   return new BuilderField('NumberRange', 'NumberRange', BuilderHelper.EFormElement.Float, 'TextField', 'fa fa-font');
  // }

  get Currency() {
    // @todo: Implement currency.
    return new BuilderField('Currency', 'Currency', BuilderHelper.EFormElement.Money, 'TextField', 'fa fa-font');
  }

  get PhoneNumber() {
    // @todo: Implement PhoneNumber.
    return new BuilderField('PhoneNumber', 'PhoneNumber', BuilderHelper.EFormElement.Float, 'TextField', 'fa fa-font');
  }

  // get Map() {
  //   // @todo: Implement map.
  //   return new BuilderField('Google Map', 'GMAP', BuilderHelper.EFormElement.CustomControl, 'Others', 'fa fa-map');
  // }

  get Adress() {
    const field = this.TextField;
    // @todo: Implement currency.
    return field;
  }

  // get Button() {
  //   return new BuilderField('Button', 'Button', BuilderHelper.EFormElement.Button, 'Others', 'fa fa-mouse-pointer');
  // }

  // get Label() {
  //   return new BuilderField('Label', 'Label', BuilderHelper.EFormElement.Label, 'Others', 'fa fa-font');
  // }

  get TextField() {
    return new BuilderField('Text Field', 'TextField', BuilderHelper.EFormElement.Text, 'TextField', 'fa fa-font');
  }

  get TextArea() {
    return new BuilderField('Text Area', 'TextArea', BuilderHelper.EFormElement.Text, 'TextField', 'fa fa-font');
  }

  get CheckBox() {
    return new BuilderField('Checkbox', 'CheckBox', BuilderHelper.EFormElement.Checkboxlist, 'Select', 'fa fa-check');
  }

  get CheckList() {
    return new BuilderField('Checklist', 'CheckList', BuilderHelper.EFormElement.Checkboxlist, 'Select', 'fa fa-check');
  }

  get DropDownList() {
    return new BuilderField('Dropdown List', 'DropdownList', BuilderHelper.EFormElement.Picklist, 'Select', 'fa fa-list-alt');
  }

  get ListField() {
    const control = new BuilderField('List Field', 'ListField', BuilderHelper.EFormElement.Picklist, 'Select', 'fa fa-list-alt');
    control.options = [new DropdownOption('Default Option', 'default')];
    return control;
  }

  // get RadioButtonList() {
  //   return new BuilderField('Radio Button List', 'RadioButtonList', BuilderHelper.EFormElement.RadioButtonList, 'Select', 'fa fa-list-ul');
  // }

  // get FileUpload() {
  //   return new BuilderField('File Upload', 'FileUpload', BuilderHelper.EFormElement.UploadFile, 'File', 'fa fa-file-o');
  // }

  // get HiddenField() {
  //   return new BuilderField('Hidden Field', 'HiddenField', BuilderHelper.EFormElement.HiddenField, 'Others', 'fa fa-eye-slash');
  // }

  get DateField() {
    return new BuilderField('Date Field', 'Date', BuilderHelper.EFormElement.DateTime, 'DateTime', 'fa fa-calendar-o');
  }

  get DateRangeField() {
    return new BuilderField('Date Range Field', 'DateRange', BuilderHelper.EFormElement.DateTime, 'DateTime', 'fa fa-calendar-o');
  }

  get DateTimeField() {
    return new BuilderField('Date/Time Field', 'DateTime', BuilderHelper.EFormElement.DateTime, 'DateTime', 'fa fa-calendar-o');
  }

  // get CustomControl() {
  //   return new BuilderField('Custom Control', 'CustomControl', BuilderHelper.EFormElement.CustomControl, 'Others', 'fa fa-cog');
  // }

  get HtmlContent() {
    return new BuilderField('HTML Control', 'HtmlContent', BuilderHelper.EFormElement.Html, 'Others', 'fa fa-html5');
  }

  get SectionLayout() {
    const control = new BuilderField('SectionLayout', 'Section Layout', null, 'Others', 'fa fa-th');
    control.rows = [{ cells: [] }];
    control.decoration = 'line';
    control.columns = 1;
    return control;
  }

  get TableLayout() {
    const control = new BuilderField('Table Layout', 'Grid', BuilderHelper.EFormElement.EditableGrid, 'Grid', 'fa fa-table');
    // control.gridConfig = new GridConfig(
    //   'SimpleGrid',
    //   new GridComponentConfig([
    //     new GridColumn('', 'default', 1, false, 'Default Column', 'gridcolumn'),
    //   ]),
    //   'DefaultGrid',
    // );
    return control;
  }
}
